module.exports = __webpack_public_path__ + "static/media/matching-score-lose.eb97afa3.png";